import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {Adresse, firstNestedSymbolControl,} from '../../models/uiArtefakt';
import {UIAusrichtung} from '../../models/uiAusrichtung';
import {ShellConfigService} from '../../services/shell-config.service';
// @ts-ignore
import {inOutAnimation, ISymbol} from '@lv1871/core';
import {TextAusrichtung} from '../../models/textAusrichtung';
import {AdressValidationService} from '../../services/adress-validation.service';
import {EventService} from '../../services/event.service';
import {UIAdressStatus} from '../../models/uiAdressStatus';
import {NgForm, NgModel} from '@angular/forms';
import {ValidationService} from '../../services/validation.service';

export interface AdressKorrektur {
  Status: string;
}

@Component({
    selector: 'lv-adress-vorschlag',
    templateUrl: './adress-vorschlag.component.html',
    styleUrls: ['./adress-vorschlag.component.scss'],
    animations: [inOutAnimation],
    standalone: false
})
export class AdressVorschlagComponent implements OnInit, AfterViewInit {
  @ViewChild(NgForm, {static: true})
  private _ngForm;

  @ViewChild('lvHiddenAdressInput')
  private _lvHiddenInput: NgModel;

  public uiAusrichtung: UIAusrichtung;
  public uiAdressStatus = UIAdressStatus;
  public textAusrichtung: TextAusrichtung = TextAusrichtung.TEXTAUSRICHTUNG_LINKSBUENDIG;
  public nestedSymbol: ISymbol;
  public showInfotextCollapsable: boolean = true;
  public isVisible: boolean = false;
  public adressKorrektur: AdressKorrektur;
  public alleAdressBestandteile: string[];
  public show: boolean = true;
  public showUntruncatedError: boolean = false;

  private _uiArtefakt: Adresse;

  constructor(private _shellConfigService: ShellConfigService,
              private _validationService: ValidationService, private _eventService: EventService,
              private _adressValidationService: AdressValidationService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): Adresse {
    return this._uiArtefakt;
  }

  public get hiddenInputmodel(): any {
    return void 0;
  }

  @Input()
  set uiArtefakt(uiArtefakt: Adresse) {
    this._uiArtefakt = uiArtefakt;
    if (!!this._uiArtefakt.WertEingabe) {
      this.adressKorrektur = JSON.parse(this._uiArtefakt.WertEingabe);
      if (!!this.adressKorrektur) {
        this.show = true;
        this.alleAdressBestandteile = Object.keys(this.adressKorrektur).filter(key => key !== 'Status');
      }
    }
  }

  public set hiddenInputmodel(value: any) {
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  public ngOnInit(): void {
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
    this._validationService.registerForm(this.uiArtefakt, this._ngForm);
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public onClick(uebernehmen: boolean) {
    this.show = false;
    this._adressValidationService.handleAdresse(this.uiArtefakt.ReferenzIdentifikator, this._uiArtefakt, uebernehmen);
  }

  public onErrorClick() {
    this.showUntruncatedError = !this.showUntruncatedError;
  }

  public getError(): string {
    if (this._lvHiddenInput?.touched) {
      return this.uiArtefakt.FehlertextPflichtfeld;
    }
    this.showUntruncatedError = false;
    return null;
  }

}
